import { patterns } from './patterns.js';
import { format } from './format.js';

function addHelperMembers(prototypeObject, membersMap) {
    for (const k in membersMap) {
        if (!prototypeObject[k]) {
            prototypeObject[k] = membersMap[k];
        }
    }
}

/**
 * Convenience function to define a custom element without having to specify its name.
 * Its name is instead pulled from the class's [is] property. Nothing special is going
 * on here, this function certainly doesn't need to be used, it simply reduces some
 * repetative/duplicate code when dealing with PolymerElement inherited classes since they need
 * to have the [is] property anyways. Not as useful for plain custom element definitions.
 * 
 * EXAMPLE:
 * window.customElements.define('my-element', class extends PolymerElement { static get is(): 'my-element' });
 * vs
 * defineElement(class extends PolymerElement { static get is(): 'my-element' });
 * 
 * @param {class} elementClass Your custom element class definition, must have an [is] property providing the element name.
 */
function defineElement(elementClass, options) {
    try {
        const helpers = {
            asBool: (x) => !!x,

            isNull: (x) => x === null,
            isSame: (x, y) => x === y,
            isSimilar: (x, y) => x == y,
            isAny: (...args) => args.reduce((v, a) => v || !!a, false),
            isAll: (...args) => args.reduce((v, a) => v && !!a, true),

            ifThen: (vIf, vThen, vElse) => vIf ? vThen : vElse,
            ifSameThen: (vIf, vSame, vThen, vElse) => vIf === vSame ? vThen : vElse,

            patterns: patterns
        };

        for (const k in format) {
            addHelperMembers(elementClass.prototype, { [`format_${k}`]: format[k] });
        }

        // Add some very simple general-use helpers.
        addHelperMembers(elementClass.prototype, helpers);

        // Define the custom element using the is() getter for the name.
        return window.customElements.define(elementClass.is, elementClass, options);
    }
    catch (err) {
        console.error('Failure in defineElement: ' + err, elementClass);
        throw err;
    }
}

export { defineElement };